// Module Import
//---------------------------------
import React, { useRef, useEffect } from 'react'
import Field from '../../atoms/fields/field'
import 'react-datepicker/dist/react-datepicker.css'
import ValidationWrapper from '../../atoms/fields/ValidationWrapper'
import {BodyWrapper, CandidateWrapper, FieldItem, FieldWrapper, Form} from "../Modals/CourseModal/CourseModal.styled";
import TypographyAtom from "../../atoms/typography/typography";

// Component Export
//---------------------------------
export default function CourseForm({
  formValues,
  onChange,
  errors,
  setFormRef,
}) {
  const formRef = useRef(null)
  const { users } = formValues

  useEffect(() => {
    if (setFormRef) setFormRef(formRef)
  }, [formRef])

  return (
    <Form id="courseForm" ref={formRef}>
      <BodyWrapper>
        {users?.map((user, i) => (
          <CandidateWrapper key={i}>
            <TypographyAtom copy={`Candidate #${i + 1}`} type="H4" weight="Light" />
            <FieldWrapper half>
              <FieldItem>
                <ValidationWrapper errorMessage={errors?.[`users[${i}].firstName`]}>
                  <Field
                    labelText={`First Name`}
                    labelFor={`firstName-${i}`}
                    placeholderText="Oliver"
                    fieldType="text"
                    fieldId={`firstName-${i}`}
                    fieldName={`users[${i}].firstName`}
                    value={user.firstName}
                    fullWidth
                    onChange={onChange}
                  />
                </ValidationWrapper>
              </FieldItem>
            </FieldWrapper>
            <FieldWrapper half>
              <FieldItem>
                <ValidationWrapper errorMessage={errors?.[`users[${i}].lastName`]}>
                  <Field
                    labelText={`Last Name`}
                    labelFor={`lastName-${i}`}
                    placeholderText="Smith"
                    fieldType="text"
                    fieldId={`lastName-${i}`}
                    fieldName={`users[${i}].lastName`}
                    value={user.lastName}
                    fullWidth
                    onChange={onChange}
                  />
                </ValidationWrapper>
              </FieldItem>
            </FieldWrapper>
            <FieldWrapper>
              <FieldItem>
                <ValidationWrapper errorMessage={errors?.[`users[${i}].email`]}>
                  <Field
                    labelText={`Email #${i+1}`}
                    labelFor={`email-${i}`}
                    placeholderText="test@example.com"
                    fieldType="email"
                    fieldId={`email-${i}`}
                    fieldName={`users[${i}].email`}
                    value={user.email}
                    fullWidth
                    onChange={onChange}
                  />
                </ValidationWrapper>
              </FieldItem>
            </FieldWrapper>
          </CandidateWrapper>
        ))}
      </BodyWrapper>
    </Form>
  )
}

CourseForm.propTypes = {}
